export const formatMonetaryValue = (
  value: string | number | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const stringValue = String(value).replace(/[^\d.]/g, "");

  if (stringValue === "" || stringValue === ".") {
    return "";
  }

  const numValue = Number.parseFloat(stringValue);

  if (Number.isNaN(numValue)) {
    return "";
  }

  return numValue.toFixed(2);
};

export const formatMonetaryInput = (value: string): string | null => {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  if (/^\d*\.?\d{0,2}$/.test(value)) {
    return value;
  }

  return null;
};
